import { Row } from 'react-bootstrap';
import Main from '../components/Layout/Main';
import Sidebar from '../components/Layout/Sidebar';
import Ansprechpartner from '../components/Sidebar/Ansprechpartner';
import PageHeader from '../components/PageHeader';
import OpenJobsLinkList from '../components/Jobs/OpenJobsLinkList';
import OpenJobsList from '../components/Jobs/OpenJobsList';
import LeftHero from '../components/Hero/LeftHero';


function Career() {
    return (
        <div class="career">
            <PageHeader title="Werde Teil von unserem Team!" />
            <Row className='page-main'>
                <Main>
                    <LeftHero
                    title="Interesse geweckt?"
                        teaser='Lust auf ein junges Unternehmen, ein super Team und viel Freiraum für persönliche Entwicklung?<br/><b>Bewirb Dich jetzt <a href="mailto:herper@heinrich-heiden.de">per Mail</a> !</b>'
                        image="/karriere.jpg" />
                        <OpenJobsLinkList />
                        <OpenJobsList />

                    <h4 className='py-2'>Wir freuen uns jederzeit über Initiativbewerbungen.</h4>
                </Main>
                
                <Sidebar>
                <h2 className='text-center py-2 man-red'>Deine Ansprech&shy;partnerin</h2>

                    <Ansprechpartner name="Claudia Herper" position="Geschäftsleitung" phone="+49 2421 9875 17" mail="herper@heinrich-heiden.de" picture="/profil_claudia.jpeg" />
                </Sidebar>
            </Row>
        </div>
      );
}

export default Career;